// Mobile-only logic for automation steps

document.querySelectorAll( "section.automation-steps .block.lg\\:hidden .overflow-x-auto" ).forEach( section => {
  const cards = section.querySelectorAll( "g.card" );
  const buttons = section.querySelectorAll( "g.button" );
  // Find the first card with class 'card dark'
  let current = Array.from( cards ).findIndex( card => card.classList.contains( 'dark' ) );
  if ( current === -1 ) current = 0;

  function activateButtons () {
    buttons.forEach( button => {
      button.classList.remove( "active", "reverse" );
      const nums = button.dataset.num.split( "" ).map( Number );
      if ( nums.includes( current ) ) button.classList.add( "active" );
      if ( nums.includes( current - 1 ) || nums.includes( current - 2 ) ) button.classList.add( "reverse" );
    } );
  }

  function centerMobile ( svg, activeCard ) {
    if ( !section || !svg || !activeCard ) return;
    const pt = svg.createSVGPoint();
    const bbox = activeCard.getBBox();
    const centerX = bbox.x + bbox.width / 2;
    pt.x = centerX;
    pt.y = 0;
    const ctm = activeCard.getScreenCTM();
    if ( !ctm ) return;
    const screenPt = pt.matrixTransform( ctm );
    const scrollerRect = section.getBoundingClientRect();
    const target = screenPt.x + section.scrollLeft - scrollerRect.left - section.clientWidth / 2;
    section.scrollTo( { left: Math.max( 0, target ), behavior: "smooth" } );
  }

  function activateCard ( suppressCenter = false ) {
    cards.forEach( card => card.classList.remove( "active" ) );
    const activeCard = cards[ current ];
    if ( !activeCard ) return;
    activeCard.classList.add( "active" );
    if ( suppressCenter ) return;
    const svg = section.querySelector( "svg" );
    centerMobile( svg, activeCard );
  }

  function handleButton () {
    activateCard();
    activateButtons();
  }

  buttons.forEach( button => {
    const numRange = button.dataset.num || "";
    const low = Number( numRange[ 0 ] );
    const high = Number( numRange[ 1 ] );
    button.addEventListener( "click", function () {
      if ( !button.classList.contains( "active" ) ) return;
      if ( low === 0 && current !== 0 ) {
        current = 0;
      } else if ( current === low ) {
        current = high;
      } else {
        current = low;
      }
      handleButton();
    } );
  } );

  // Swipe navigation for mobile
  let startX = 0;
  let startY = 0;
  let isTouch = false;
  const threshold = 40;
  const onStart = ( x, y ) => {
    startX = x;
    startY = y;
    isTouch = true;
  };
  const onEnd = ( x, y ) => {
    if ( !isTouch ) return;
    const dx = x - startX;
    const dy = y - startY;
    isTouch = false;
    if ( Math.abs( dx ) > Math.abs( dy ) && Math.abs( dx ) > threshold ) {
      if ( dx < 0 && current < cards.length - 1 ) {
        current += 1;
      } else if ( dx > 0 && current > 0 ) {
        current -= 1;
      }
      handleButton();
    }
  };
  section.addEventListener( "touchstart", e => {
    if ( e.touches && e.touches[ 0 ] ) onStart( e.touches[ 0 ].clientX, e.touches[ 0 ].clientY );
  }, { passive: true } );
  section.addEventListener( "touchend", e => {
    const t = e.changedTouches && e.changedTouches[ 0 ];
    if ( t ) onEnd( t.clientX, t.clientY );
  }, { passive: true } );
  // Optional mouse swipe (drag) support
  let mouseDown = false;
  section.addEventListener( "mousedown", e => {
    mouseDown = true;
    onStart( e.clientX, e.clientY );
  } );
  window.addEventListener( "mouseup", e => {
    if ( !mouseDown ) return;
    mouseDown = false;
    onEnd( e.clientX, e.clientY );
  } );

  // Sync active card to scroll position on mobile (nearest to center)
  let ticking = false;
  const svg = section.querySelector( "svg" );
  const updateActiveFromScroll = () => {
    ticking = false;
    if ( !svg ) return;
    const rect = section.getBoundingClientRect();
    const viewportCenterX = rect.left + section.clientWidth / 2;
    let bestIdx = current;
    let bestDist = Infinity;
    cards.forEach( ( card, idx ) => {
      const bbox = card.getBBox();
      const pt = svg.createSVGPoint();
      pt.x = bbox.x + bbox.width / 2;
      pt.y = 0;
      const ctm = card.getScreenCTM();
      if ( !ctm ) return;
      const screenPt = pt.matrixTransform( ctm );
      const dist = Math.abs( screenPt.x - viewportCenterX );
      if ( dist < bestDist ) {
        bestDist = dist;
        bestIdx = idx;
      }
    } );
    if ( bestIdx !== current ) {
      current = bestIdx;
      activateCard( true );
      activateButtons();
    }
  };
  section.addEventListener( "scroll", () => {
    if ( !ticking ) {
      requestAnimationFrame( updateActiveFromScroll );
      ticking = true;
    }
  }, { passive: true } );

  // Initialize: activate the first card with class 'card dark' and button with data-num="01"
  cards.forEach( card => card.classList.remove( "active" ) );
  if ( cards[ current ] ) cards[ current ].classList.add( "active" );
  buttons.forEach( button => button.classList.remove( "active" ) );
  const firstBtn = Array.from( buttons ).find( btn => btn.dataset.num === "01" );
  if ( firstBtn ) firstBtn.classList.add( "active" );
  section.scrollLeft = 0;
  activateButtons();
} );
